import React from 'react'


import { Card } from 'primereact/card';
import { AuthContext } from '../../main/ProvedorAutenticacao'
import { withRouter } from 'react-router-dom'
import { Toast } from 'primereact/toast';
import { Chart } from 'primereact/chart';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import GraficosService from '../../app/service/GraficoPessoasService'

import '../../pages/processo/calendario.css'

class Graficcos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      graficoFaixaEtaria: [],
      graficoProfissao: [],
      openSpinner: false,
      detail: '',
    }

    this.options = this.getLightTheme();

    this.graficoService = new GraficosService();
  }

  faixaEtaria = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoService.faixaEtaria(usuarioLogado.empresa.codigo)
      .then(response => {
        //Faixas
        let faixas = [];
        for(let i = 0; i < response.data.length; i++) {
          faixas.push(response.data[i].faixa);
        }
        //Cores
        let cores = [];
        for(let i = 0; i < response.data.length; i++) {
          cores.push(response.data[i].cor);
        }

        //Quantidade
        let quantidades = [];
        for(let i = 0; i < response.data.length; i++) {
          quantidades.push(response.data[i].quantidade);
        }

        this.setState({graficoFaixaEtaria: {
          labels: faixas,
          datasets: [
            {
              data: quantidades,
              backgroundColor: cores,
            }
          ]
        }});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Faixa Etária', detail:`${this.state.detail}`, life: 4000});
      })
  }

  profissao = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoService.profissao(usuarioLogado.empresa.codigo)
      .then(response => {
        //Profissoes
        let profissoes = [];
        for(let i = 0; i < response.data.length; i++) {
          profissoes.push(response.data[i].profissao);
        }
        //Cores
        let cores = [];
        for(let i = 0; i < response.data.length; i++) {
          cores.push(response.data[i].cor);
        }

        //Quantidade
        let quantidades = [];
        for(let i = 0; i < response.data.length; i++) {
          quantidades.push(response.data[i].quantidade);
        }

        this.setState({graficoProfissao: {
          labels: profissoes,
          datasets: [
            {
              data: quantidades,
              backgroundColor: cores,
            }
          ]
        }});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Profissões', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.faixaEtaria();
    await this.profissao();
    this.setState({openSpinner: false});
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let basicOptions2 = {
      maintainAspectRatio: false,
      aspectRatio: .8,
        plugins: {
            
        },
        scales: {
            
        }
    };

    let horizontalOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let multiAxisOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057',
                }
            },
            tooltips: {
                mode: 'index',
                intersect: true
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                    color: '#ebedef'
                },
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                }
            }
        }
    };

    return {
        basicOptions,
        basicOptions2,
        horizontalOptions,
        stackedOptions,
        multiAxisOptions
    }
  }

  render() {
    const { basicOptions, basicOptions2, horizontalOptions, multiAxisOptions, stackedOptions } = this.options;
    return(
      <>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <div class="cardMiniAgendaPainel">
                    <div class="card-header-MiniAgenda">
                      <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                        <h5>Faixa-Etária</h5> 
                      </span>
                    </div>
                    <div class="card-content-MiniAgenda">
                      <div> 
                        <Chart type="pie" data={this.state.graficoFaixaEtaria} options={basicOptions2} style={{ position: 'relative', width: '100%' }} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div class="cardMiniAgendaPainel">
                    <div class="card-header-MiniAgenda">
                      <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                        <h5>Profissões</h5> 
                      </span>
                    </div>
                    <div class="card-content-MiniAgenda">
                      <div> 
                        <Chart type="doughnut" data={this.state.graficoProfissao} options={basicOptions2} style={{ position: 'relative', width: '100%' }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
Graficcos.contextType = AuthContext;
export default withRouter(Graficcos)
